import { render, staticRenderFns } from "./EmailTemplateModal.vue?vue&type=template&id=80cd4ef0&scoped=true&"
import script from "./EmailTemplateModal.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateModal.vue?vue&type=style&index=0&id=80cd4ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cd4ef0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80cd4ef0')) {
      api.createRecord('80cd4ef0', component.options)
    } else {
      api.reload('80cd4ef0', component.options)
    }
    module.hot.accept("./EmailTemplateModal.vue?vue&type=template&id=80cd4ef0&scoped=true&", function () {
      api.rerender('80cd4ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CustomActions/Email/EmailTemplateModal.vue"
export default component.exports